const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SaleServiceCommand: any = {
    UpdateSaleOrderShippingAddress: Backofficebff + '/v1/sale/UpdateSaleOrderShippingAddress',
    UpdateSaleOrderBillingAddress: Backofficebff + '/v1/sale/UpdateSaleOrderBillingAddress',
};
